import { render, staticRenderFns } from "./RewardConfig.vue?vue&type=template&id=30f387d5&scoped=true"
import script from "./RewardConfig.vue?vue&type=script&lang=js"
export * from "./RewardConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f387d5",
  null
  
)

export default component.exports